import { EntityId } from '../EntityId';
import { IDeletable } from '../IDeletable';

export interface ArmyListUnitOption extends EntityId<string>, IDeletable {
  points: number;
  quantity: number;
  unit_option_id: number;
}

export const dupArmyListUnitUnitOption = (
  item: ArmyListUnitOption,
): ArmyListUnitOption =>
  ({
    ...item,
    id: '',
  }) satisfies ArmyListUnitOption as ArmyListUnitOption;

export const copyArmyListUnitUnitOption = (
  item: ArmyListUnitOption,
): ArmyListUnitOption =>
  ({
    ...item,
  }) satisfies ArmyListUnitOption as ArmyListUnitOption;
